<template>
  <el-dialog v-model="dialogVisibility" :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
    <el-form v-loading="dialogBusy" ref="editorForm" :model="formModel" :rules="formRules" label-width="120px">
      <!-- Facility -->
      <el-form-item label="Facility" prop="facility">
        <el-select v-model="formModel.facility" value-key="id" filterable>
          <el-option v-for="item in sites" :key="item.id" :label="item.displayText" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>
      <!-- Unit -->
      <el-form-item label="Unit" prop="unit">
        <el-select v-model="formModel.unit" value-key="id" filterable :disabled="formModel.facility === null">
          <el-option v-for="item in units" :key="item.id" :label="item.displayText" :value="item"> </el-option>
        </el-select>
      </el-form-item>
      <!-- Observer -->
      <el-form-item label="Observer" prop="observer">
        <!-- <RemoteSelect v-if="useCulledObservers" :defaultOptions="scopedObservers" :fetch="observerFetchFn" v-model="formModel.observer" /> -->
        <el-select v-model="formModel.observer" filterable :disabled="formModel.facility === null">
          <el-option v-for="item in scopedObservers" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-form-item>
      <!-- HCW Type -->
      <el-form-item label="HCW Type" prop="workerType">
        <el-select v-model="formModel.workerType">
          <el-option v-for="item in healthcareWorkers" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
      </el-form-item>
      <!-- Moment -->
      <el-form-item label="Moment" prop="moment">
        <el-select v-model="formModel.moment">
          <el-option v-for="item in hhMoments" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
      </el-form-item>
      <!-- Outcome + Seconds -->
      <el-form-item label="Outcome" prop="outcome">
        <el-radio-group v-model="formModel.outcome">
          <el-radio-button label="Wash"></el-radio-button>
          <el-radio-button label="Rub"></el-radio-button>
          <el-radio-button label="Missed"></el-radio-button>
        </el-radio-group>
      </el-form-item>
      <template v-if="formModel.outcome === 'Wash' || formModel.outcome === 'Rub'">
        <el-form-item label="Seconds" prop="outcomeSeconds">
          <el-input-number v-model="formModel.outcomeSeconds" :min="0"></el-input-number>
        </el-form-item>
      </template>
      <!-- Assigned Name -->
      <el-form-item label="Name" prop="assignedName" v-if="hasAssignee() && formModel.facility !== null">
        <template v-if="assigneeType() === 'Staff'">
          <el-select filterable clearable allow-create v-model="formModel.assignedName">
            <el-option v-for="item in staff" :key="item.id" :label="item.firstName + ' ' + item.lastName" :value="item.firstName + ' ' + item.lastName"> </el-option>
          </el-select>
        </template>
        <template v-if="assigneeType() === 'FreeText'">
          <el-input style="width:190px;" v-model="formModel.assignedName"></el-input>
        </template>
      </el-form-item>
      <!-- Collection Date -->
      <el-form-item label="Collection Date" prop="collectionDate">
        <el-date-picker v-model="formModel.collectionDate" type="datetime" placeholder="Select date and time"> </el-date-picker>
      </el-form-item>
      <!-- Custom Type  -->
      <el-form-item label="Custom Types" prop="customTypes">
        <el-checkbox-group v-model="formModel.customTypes">
          <el-checkbox v-for="type in customTypes" :key="type" :label="type"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <!-- Comments  -->
      <el-form-item label="Comments" prop="comments">
        <el-input type="textarea" v-model="formModel.comments" :maxlength="250"></el-input>
        <CharacterCount :limit="250" :count="formModel.comments.length" />
      </el-form-item>
      <div class="dialog-footer">
        <el-button data-testid="cancel-observation" @click="cancelForm" :disabled="dialogBusy">Cancel</el-button>
        <el-button data-testid="save-observation" type="primary" @click="commitForm" :disabled="dialogBusy">Save</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>
<script>
const validateNotEmpty = (rule, value, callback) => {
  if (!value) {
    callback("This field cannot be empty");
  }
  callback();
};
import auth from "../../auth";
import CharacterCount from "../Shared/CharacterCount.vue";
// import RemoteSelect from "../Shared/RemoteSelect.vue";
export default {
  name: "observation-editor",
  props: ["title", "values"],
  components: {
    CharacterCount,
    // RemoteSelect
  },
  data() {
    return {
      useCulledObservers: false,
      dialogVisibility: true,
      dialogBusy: true,
      observerFetchFn: () => Promise.resolve([]),
      organization: null,
      sites: [],
      healthcareWorkers: [],
      scopedStaff: [],
      scopedObservers: [],
      hhMoments: [],
      customTypes: {},
      formRules: {
        observer: [{ required: true, message: "This field is required", trigger: "blur" }],
        facility: [{ required: true, validator: validateNotEmpty, message: "This field  is required", trigger: "blur" }],
        unit: [{ required: true, validator: validateNotEmpty, message: "This field  is required", trigger: "blur" }],
        workerType: [{ required: true, message: "This field  is required", trigger: "blur" }],
        moment: [{ required: true, message: "This field  is required", trigger: "blur" }],
        collectionDate: [{ required: true, validator: validateNotEmpty, message: "This field  is required", trigger: "blur" }],
        outcome: [{ required: true, message: "This field  is required", trigger: "blur" }]
      },
      formModel: {
        id: null,
        created: null,
        createdBy: null,
        active: true,
        observer: auth.userInfo().username,
        facility: null,
        unit: null,
        workerType: null,
        moment: null,
        outcome: null,
        assignedName: null,
        outcomeSeconds: 0,
        collectionDate: null,
        customTypes: [],
        comments: ""
      }
    };
  },
  computed: {
    units() {
      if (this.formModel.facility !== null) {
        return this.sites.filter(s => s.id === this.formModel.facility)[0].units.filter((unit) => unit.archived !== true);
      }
      return [];
    },
    staff() {
      return this.scopedStaff;
    },
  },
  watch: {
    dialogVisibility(val) {
      if (val === false) {
        this.cancelForm();
      }
    },
    "formModel.facility"() {
      this.getStaff();
      this.getObservers();
    }
  },
  methods: {
    async getStaff() {
      let facId = "";
      if (this.formModel.facility !== null) {
        facId = `&facIds=${this.formModel.facility}`;
      }
      const staff = await this.$http.get(`${window.CONFIG.client_api}/staff-abridged?status=C${facId}`).then(response => response.body);
      this.scopedStaff = staff;
    },
    async getObservers() {
      let urlForObservers = '/observers';
      if (this.useCulledObservers) {
        urlForObservers = '/limited-observers';
      }
      const params = {facilityIds: undefined}
      if (this.formModel.facility !== null) {
        params.facilityIds = [this.formModel.facility]
      }
      this.scopedObservers = await this.$http
        .get(`${window.CONFIG.hh_api}${urlForObservers}`, { params })
        .then(response => response.body)
        .then(observers => {
          return Array.from(new Set([...observers, ...[auth.userInfo().username]]).keys()).map(id => ({label: id, value: id}));
        });
    },
    setupForm(values) {
      this.formModel.id = values.id;
      this.formModel.created = values.created;
      this.formModel.createdBy = values.createdBy;
      this.formModel.active = values.active;
      this.formModel.observer = values.observerName;
      this.formModel.facility = this.sites.filter(s => s.id === Number(values.facId))[0].id;
      this.formModel.unit = this.sites.filter(s => s.id === Number(values.facId))[0].units.filter(u => u.id === Number(values.unitId))[0];
      this.formModel.outcome = values.outcome.outcome;
      this.formModel.outcomeSeconds = values.outcome.seconds;
      this.formModel.workerType = values.workerType;
      this.formModel.assignedName = values.assignedName;
      this.formModel.moment = values.moment;
      this.formModel.comments = values.comments;
      this.formModel.collectionDate = values.collectionDate;
      this.formModel.customTypes = Object.entries(values.customTypes)
        .filter(([, value]) => value)
        .map(([key]) => key);
    },
    cancelForm() {
      this.$emit("editor-close");
    },
    isHHAdmin: function() {
      return auth.userInfo().roles.indexOf("ROLE_HH_ADMIN") >= 0;
    },
    hasAssignee() {
      return !!this.$configStore.hhAssignedNameType();
    },
    assigneeType() {
      return this.$configStore.hhAssignedNameType();
    },
    async commitForm() {
      this.$refs.editorForm.validate(async valid => {
        if (valid) {
          this.dialogBusy = true;
          const raw = { ...this.formModel };
          const formData = {};
          if (raw.id !== null) {
            formData.id = raw.id;
          }
          formData.outcome = {
            outcome: raw.outcome,
            seconds: raw.outcome === "Missed" ? 0 : raw.outcomeSeconds
          };
          formData.created = raw.created;
          formData.createdBy = raw.createdBy;
          formData.active = raw.active;
          formData.observerName = raw.observer;
          formData.collectionDate = new Date(raw.collectionDate).getTime();
          formData.facId = raw.facility;
          formData.unitId = raw.unit.id;
          formData.unitName = raw.unit.displayText;
          formData.assignedName = raw.assignedName;
          formData.workerType = raw.workerType;
          formData.moment = raw.moment;
          formData.comments = raw.comments;
          formData.customTypes = this.customTypes.map(type => {
            return {
              type: type,
              checked: raw.customTypes.includes(type)
            };
          });
          const useNewEndpoints = await this.getFeatureFlag('IPAC_LEGACY_API_ROLLOUT');
          const url = useNewEndpoints ? `${window.CONFIG.legacy_facade_api}/handhygiene/observations` : `${window.CONFIG.api}/handhygiene/observations`;
          if (formData.id) {
            await this.$http.put(url + "/" + formData.id, JSON.stringify(formData));
          } else {
            await this.$http.post(url, JSON.stringify([formData]));
          }
          this.$emit("editor-save");
        } else {
          return false;
        }
      });
    }
  },
  async created() {
    this.useCulledObservers = await this.getFeatureFlag("IPAC_OBSERVER_LIST_PERF");

    const useNewEndpoints = await this.getFeatureFlag('IPAC_LEGACY_API_ROLLOUT');
    const url = useNewEndpoints ? `${window.CONFIG.legacy_facade_api}/handhygiene/settings?facId=1` : `${window.CONFIG.api}/handhygiene/settings?facId=1`;
    const hhSettings = await this.$http.get(url).then(response => response.body);

    this.healthcareWorkers = hhSettings.workers;
    this.hhMoments = hhSettings.moments;
    this.customTypes = hhSettings.customTypes;
    this.organization = this.$configStore.data.organization[0];
    this.sites = this.$configStore.data.sites;
    if (this.values) {
      this.setupForm(this.values);
    } else if (this.sites.length === 1) {
      this.formModel.facility = this.sites[0].id;
    }
    this.dialogBusy = false;
  }
};
</script>
